/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SalesManApi } from '../api/salesman.api';
import { switchMap, map } from 'rxjs/operators';
import { SalesManData, SalesMan } from '../../../interfaces/masters/salesman';

@Injectable()
export class SalesManService extends SalesManData {

  constructor(private api: SalesManApi) {
    super();
  }

  list(url: string): Observable<SalesMan[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<SalesMan>{
      return this.api.getById(url);
  }

  create(url: string, data:SalesMan): Observable<SalesMan> {
    return this.api.add(url,data);
  }

  update(url: string, data:SalesMan): Observable<SalesMan> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
